<template>
    <div class="equipment_management">
      <div style="padding: 0px 20px">
        <div class="search">
          <div class="search_box">
            <div v-for="item in search" :class='["search_options_box"]'>
              <span>{{item.title}}</span>
              <img src="/static/img/select.png" alt="">
              <select class="select">
                <option v-for="item2 in item.select" v-bind:value='item2.option'>{{item2.option}}</option>
              </select>
            </div>
            <div class="search_btn_box">
              <button :class='["search_btn","green","icon_btn","clearborder"]'><span class="icon-9"></span>搜索</button>
            </div>
            <div class="add_btn_box">
              <button :class='["add_btn","add","icon_btn","clearborder"]'><span class="icon-9"></span>添加</button>
              <button :class='["add_btn","delete","icon_btn","clearborder"]'><span class="icon-9"></span>删除</button>
            </div>
          </div>
        </div>

        <!--        表格-->
        <div class="table_content">
          <table>
            <thead>
            <tr>
              <th style="padding-left: 30px">序号</th>
              <th>位置</th>
              <th>灯杆编号</th>
              <th>传感器名称</th>
              <th>传感器类型</th>
              <th>状态</th>
              <th>创建时间</th>
              <th>操作</th>
            </tr>
            </thead>
            <tbody>
            <tr  v-for="(item,index) in tabledata">
              <td style="padding-left: 30px">{{index+1}}</td>
              <td>{{item.address}}</td>
              <td>{{item.num}}</td>
              <td>{{item.name}}</td>
              <td>{{item.type}}</td>
              <td>{{item.state}}</td>
              <td>{{item.time}}</td>
              <td class="table_btn_box">
                <button class="table_btn" style=" margin-right: 20px;">{{item.btn24}}</button>
                <button class="table_btn">{{item.btninfor}}</button></td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="table_paging">
          <p>当前记录<span>1</span>到<span>5</span>条，共<span>45</span>条记录
            <button
              v-bind:style="[{background:'url(/static/img/icon/table_start.png) no-repeat center center'}]"></button>
            <button
              v-bind:style="[{background:'url(/static/img/icon/table_prep.png) no-repeat center center'}]"></button>
            第<span>1</span>/<span>5</span>页
            <button
              v-bind:style="[{background:'url(/static/img/icon/table_next.png) no-repeat center center'}]"></button>
            <button
              v-bind:style="[{background:'url(/static/img/icon/table_end.png) no-repeat center center'}]"></button>
          </p>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "equipment_management",
      data() {
        return {
          search: [
            {
              title: '选择项目',
              select: [
                {option: "请选择项目"},
                {option: "项目1"},
              ]
            }, {
              title: '选择区域',
              select: [
                {option: "请选择区域"},
                {option: "区域1"},
              ]
            }, {
              title: '选择分组',
              select: [
                {option: "请选择分组"},
                {option: "分组1"},
              ]
            }, {
              title: '选择灯杆',
              select: [
                {option: "请选择灯杆"},
                {option: "灯杆1"},
              ]
            }
          ],
          tabledata: [
            {
              time: "2019-08-13 星期五",
              address: "石家庄市桥西区智达光电研发中心",
              num: "灯杆001",
              name: "灯杆1传感器001",
              type: "-",
              state: "-",
              time: "2019-08-13 10:23:36",
              btn24:"编辑",
              btninfor:"删除"
            },{
              time: "2019-08-13 星期五",
              address: "石家庄市桥西区智达光电研发中心",
              num: "灯杆001",
              name: "灯杆1传感器001",
              type: "-",
              state: "-",
              time: "2019-08-13 10:23:36",
              btn24:"编辑",
              btninfor:"删除"
            },{
              time: "2019-08-13 星期五",
              address: "石家庄市桥西区智达光电研发中心",
              num: "灯杆001",
              name: "灯杆1传感器001",
              type: "-",
              state: "-",
              time: "2019-08-13 10:23:36",
              btn24:"编辑",
              btninfor:"删除"
            },{
              time: "2019-08-13 星期五",
              address: "石家庄市桥西区智达光电研发中心",
              num: "灯杆001",
              name: "灯杆1传感器001",
              type: "-",
              state: "-",
              time: "2019-08-13 10:23:36",
              btn24:"编辑",
              btninfor:"删除"
            },{
              time: "2019-08-13 星期五",
              address: "石家庄市桥西区智达光电研发中心",
              num: "灯杆001",
              name: "灯杆1传感器001",
              type: "-",
              state: "-",
              time: "2019-08-13 10:23:36",
              btn24:"编辑",
              btninfor:"删除"
            },{
              time: "2019-08-13 星期五",
              address: "石家庄市桥西区智达光电研发中心",
              num: "灯杆001",
              name: "灯杆1传感器001",
              type: "-",
              state: "-",
              time: "2019-08-13 10:23:36",
              btn24:"编辑",
              btninfor:"删除"
            },{
              time: "2019-08-13 星期五",
              address: "石家庄市桥西区智达光电研发中心",
              num: "灯杆001",
              name: "灯杆1传感器001",
              type: "-",
              state: "-",
              time: "2019-08-13 10:23:36",
              btn24:"编辑",
              btninfor:"删除"
            },{
              time: "2019-08-13 星期五",
              address: "石家庄市桥西区智达光电研发中心",
              num: "灯杆001",
              name: "灯杆1传感器001",
              type: "-",
              state: "-",
              time: "2019-08-13 10:23:36",
              btn24:"编辑",
              btninfor:"删除"
            },{
              time: "2019-08-13 星期五",
              address: "石家庄市桥西区智达光电研发中心",
              num: "灯杆001",
              name: "灯杆1传感器001",
              type: "-",
              state: "-",
              time: "2019-08-13 10:23:36",
              btn24:"编辑",
              btninfor:"删除"
            }
          ]
        }
      },
      methods:{
        InitLeftMenu:function () {
          this.$emit('getMessage', '1','2');
        }
      },
      created(){
        this.InitLeftMenu()
      }
    }
</script>

<style scoped>
  .table_content{
    width: 100%;
    height: calc(100% - 100px);
    padding: 20px 0px;
  }

  .table_content > table {
    width: 100%;
    height: 100%;
    border: 1px solid #094b8e;
    background-color: #16518d;
  }

  .table_content > table tr th{
    background-color: #0e345b;
  }
  .table_content > table tr td{
    /*background-color: #16518d;*/
  }

  .table_content > table tr td input{
    width: 16px;
    height: 16px;

  }

  .table_content > table tr:nth-child(2n){
    background-color: #11406f;
  }

  .table_content > table tr {
    /*border-bottom: 1px solid #225892;*/
    height: 62px
  }

  .table_content > table tr td, .table_content > table tr th {
    text-align: center;
    color: #FFFFFF;
  }

  .table_paging {
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid #105ba8;
    border-radius: 6px;
  }

  .table_paging > p {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: right;
    margin-bottom: 0;
    color: #c1c2c6;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
  }

  .table_paging > p > button {
    margin: 0 8px;
    width: 10px;
    height: 16px;
    border: none;
    outline: none;
  }

  .table_btn{
    color: #95bee5;
    background: transparent;
    border: 1px solid #95bee5;
    outline: transparent;
    padding: 5px 20px;
    border-radius: 6px;
  }

</style>



// WEBPACK FOOTER //
// src/components/03Monitoring/2_environment/equipment_management.vue